"use client";

import { ReactNode, useState } from "react";
import { PostComposer, type PostComposerProps } from "./PostComposer";

/**
 * EPIC-047 — universal client-side wrapper that renders a CTA button
 * + the PostComposer modal it opens. Used everywhere the unified
 * composer is invoked (SiteHeader "+ Post", topic page "+ New
 * discussion", profile "+ Post", trade-confirm "Add commentary").
 *
 * Server-rendered host pages (e.g., /topic/[slug]) can drop this in
 * directly — the "use client" boundary is local to the wrapper, so
 * the rest of the page stays an RSC.
 */
export function ComposerButton(props: {
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
  initialDestination?: PostComposerProps["initialDestination"];
  initialAttachedMarketId?: PostComposerProps["initialAttachedMarketId"];
  initialBody?: string;
  initialSentiment?: "bullish" | "bearish" | null;
  onPublished?: PostComposerProps["onPublished"];
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={props.className}
        aria-label={props.ariaLabel}
      >
        {props.children}
      </button>
      <PostComposer
        open={open}
        onClose={() => setOpen(false)}
        initialDestination={props.initialDestination}
        initialAttachedMarketId={props.initialAttachedMarketId}
        initialBody={props.initialBody}
        initialSentiment={props.initialSentiment}
        onPublished={props.onPublished}
      />
    </>
  );
}
